export default function toggleAccordions() {
    const $accordionSelector = '[data-accordion-item]';
    const $accordionTitleSelector = '[data-accordion-title]';
    const $accordionContentSelector = '[data-tab-content]';
    if (!$($accordionSelector).length) return;

    console.log('Initializing accordions...');

    $(document).on('click', $accordionTitleSelector, function (e) {
        e.preventDefault();
        console.log('Accordion title clicked:', this);
        const $item = $(this).closest($accordionSelector);
        const $content = $item.find($accordionContentSelector);
        const isOpen = $item.hasClass('is-open');
        $($accordionSelector).removeClass('is-open').find($accordionContentSelector).slideUp(150);
        if (!isOpen) {
            $item.addClass('is-open');
            $content.slideDown(150);
        }
    });
}